export default "__VITE_ASSET__cb5b7a94__"